import { useStoreValue } from '@core'
import { getAppContext } from 'src/context/AppContext'
import { Language } from '../api/defs/enums.type'

// TODO very simple
const isUrl = (str: string) => str.includes('://')

export const useI18nDownloadLink = (linkTemplate: string) => {
    const lang = useStoreValue(getAppContext().i18n.language)
    const country = getAppContext().config.boxylandCountry
    const langBE = lang === Language.CS ? 'cz' : lang.toLowerCase()

    // TODO maybe check only template results - correct but more expensive approach
    if (!isUrl(linkTemplate))
        throw new Error(`Link template is not an URL: ${linkTemplate}`)
    const link = linkTemplate
        .replace('{lang}', langBE)
        .replace('{country}', country)
    return link
}
